module.exports = __webpack_public_path__ + "img/bg7.591d8a46.jpg";